/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';

class Icon extends React.Component {
  static propTypes = {
    id: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
    onClick: PropTypes.func.isRequired,
    onMouseEnter: PropTypes.func.isRequired,
  };

  handleClick = () => {
    const { onClick, id } = this.props;
    onClick(id);
  };

  handleMouseEnter = () => {
    const { onMouseEnter, id } = this.props;
    onMouseEnter(id);
  };

  render() {
    const props = omit(this.props, ['id', 'onClick', 'onMouseEnter']);

    return (
      <i
        {...props}
        onClick={this.handleClick}
        onMouseEnter={this.handleMouseEnter}
      />
    );
  }
}

export default Icon;
